module.exports = __webpack_public_path__ + "static/media/Flecha_izquierda.923b7cd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Flecha_izquierda.svg
// module id = 6489
// module chunks = 16